/* global currentUser:true PubSub:true */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bowserFlags } from 'lib/bowser'
import cx from 'classnames'

import * as blUrls from 'lib/urls'
import * as css from './mobile-tab-bar.scss'
import Tappable from 'react-tappable'

import { SHOW_APP_MODAL_EVENT, SHOW_MOBILE_NAV_EVENT } from 'shared/constants'

class MobileTabBar extends Component {
  static propTypes = {
    isRegistryPage: PropTypes.bool,
    isHelloBabyPage: PropTypes.bool,
    isStorePage: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      isVisible: props.isVisible || false,
      currentUser: props.currentUser || null,
    }
  }

  componentDidMount() {
    PubSub.subscribe(SHOW_MOBILE_NAV_EVENT, (event) => {
      if (bowserFlags.mobile) {
        this.setState({ isVisible: true })
      }
    })

    //bootstrap
    setTimeout(() => {
      PubSub.publish(SHOW_MOBILE_NAV_EVENT)
    }, 1)
  }

  render() {
    if (!this.state.isVisible) {
      return null
    }
    let homeUrl = this.state.currentUser
      ? blUrls.registryHomePath
      : blUrls.indexPath
    let registryUrl = this.state.currentUser
      ? blUrls.registryPath(this.state.currentUser.registryUrlSlug)
      : blUrls.whyBabyListPath

    return (
      <div className={css.affixMobileNav}>
        <div className={css.mobileMenuContainer}>
          <Tappable
            component="a"
            href={homeUrl}
            className={cx({ [css.active]: this.props.isHomePage })}
          >
            <div className={cx(css.iconMobileNav, css.iconHome)} />
            <span className={css.iconText}>Home</span>
          </Tappable>
          <Tappable
            component="a"
            href={registryUrl}
            className={cx({ [css.active]: this.props.isRegistryPage })}
          >
            <div className={cx(css.iconMobileNav, css.iconRegistry)} />
            <span className={css.iconText}>Registry</span>
          </Tappable>
          <Tappable
            component="a"
            href={'javascript:void(0)'}
            onClick={() =>
              PubSub.publish(SHOW_APP_MODAL_EVENT, {
                mobileNavTest: this.props.mobileNavTest,
              })
            }
          >
            <div className={cx(css.iconMobileNav, css.iconAnyStore)} />
            <span className={css.iconText}>Add Items</span>
          </Tappable>
          <Tappable
            component="a"
            href={blUrls.helloBabyPath}
            className={cx({ [css.active]: this.props.isHelloBabyPage })}
          >
            <div className={cx(css.iconMobileNav, css.iconGuides)} />
            <span className={css.iconText}>Guides</span>
          </Tappable>
          <Tappable
            component="a"
            href={blUrls.catalogPath}
            className={cx({ [css.active]: this.props.isStorePage })}
          >
            <div className={cx(css.iconMobileNav, css.iconStore)} />
            <span className={css.iconText}>Store</span>
          </Tappable>
        </div>
      </div>
    )
  }
}

export default MobileTabBar
